import { render } from "./TranslationKeyItem.vue?vue&type=template&id=6a31ea88&scoped=true"
import script from "./TranslationKeyItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TranslationKeyItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./TranslationKeyItem.vue?vue&type=style&index=0&id=6a31ea88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a31ea88"]])

export default __exports__